import axios from "axios";
import { getENVData } from "../config/environment";
import { APIOptions, APIResponse } from "./interfaces";

export function getUuid(payload: any = ""): Promise<any> {
  const currentAccount: any = window.localStorage.getItem("currentAccount");
  if (currentAccount) {


    console.log("currentAccount", JSON.parse(currentAccount))
    const data: any = JSON.parse(currentAccount);
    const uuid = data.telco_id !== "undefined" ? data.telco_id : data.tenant_id;
    console.log("uuididididididi", uuid, payload)
    if (payload && data?.type && !payload[data.type + "_id"]) {
      payload[data.type + "_id"] = data.uuid;
    } else if (data.nonce) {
      if (payload === "") {
        payload = uuid;
      } else {
        payload[(data.telco_id !== "undefined" ? "telco" : "tenant") + "_id"] =
          uuid;
      }
    } else if (payload === "") {
      payload = data.uuid;
    }
  }
  console.log("payload", payload)
  return payload;
}
export async function post(url: string, payload: any = {}, options: any = {}, headers: any = {}): Promise<any> {
  if (options?.skipHeader) {

  } else {
    payload = getUuid(payload)
    console.log("getUUiDpaylaod", getUuid(payload))
  }
  var fullUrl = getENVData().baseURL + url
  if (options?.source === 'keyCloak') {
    delete axios.defaults.headers.common["x-auth-token"];
    fullUrl = getENVData().keyCloak + url
  }
  console.log("payload", payload, headers)
  const result: any = await axios.post(fullUrl, payload, headers).then((response) => {
    return response.data
  }).catch(err => {
    const data = {
      status: err?.response?.status || 'not available',
      data: err?.response?.data || [],
      message: err?.message || ''
    }
    console.error("POST Error", { url: fullUrl, path: url, status: err?.response?.status || 'not available', payload: payload, code: err.code, message: err.message });
    return data
  })
  return result;
}

export async function remove(url: string, payload: any = {}): Promise<any> {
  payload = getUuid(payload);
  console.log("getUUiDpaylaod", getUuid(payload))

  const result: any = await axios
    .delete(getENVData().baseURL + url, { data: payload })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      const data = {
        status: err.response.status,
        data: err.response.data,
        message: err.message,
      };
      console.error("DELETE Error", {
        url: getENVData().baseURL + url,
        path: url,
        status: err.response.status,
        payload: payload,
        code: err.code,
        message: err.message,
      });
      return data;
    });
  return result;
}
export async function put(
  url: string,
  payload: any = {},
  options: any = {}
): Promise<any> {
  if (options?.skipHeader) {
  } else {
    payload = getUuid(payload);
    console.log("getUUiDpaylaod", getUuid(payload))

  }
  const result: any = await axios
    .put(getENVData().baseURL + url, payload)
    .then((response) => {
      return response.data;
    });
  return result;
}
/**
 * Retrieves data from a specified endpoint using an HTTP GET request.
 *
 * @param {string} endpoint - The endpoint to retrieve data from.
 * @param {APIOptions} options - Additional options for the API request (default is an empty object).
 * @return {Promise<any>} An object containing the success status, HTTP status code, and data retrieved.
 */
export async function get(
  endpoint: string,
  options: APIOptions
): Promise<APIResponse> {
  const { data, status } = await axios
    .get(getENVData().baseURL + endpoint)
    .then((response) => ({ data: response.data, status: response.status }))
    .catch((error) => ({ data: [], status: error.response?.status }));

  return { success: isSuccessCode(status), status, data };
}

function isSuccessCode(status: any): boolean {
  throw new Error("Function not implemented.");
}
